import axios from 'axios'

const cpfApi = axios.create({
    baseURL: `https://api.cpfcnpj.com.br/${process.env.REACT_APP_CPF_TOKEN}/1/`
})

export default cpfApi
